import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import useProject from "hooks/useProject";
import IndividualItemResponse from "types/IndividualItemResponse";
import ScriptDto from "types/ScriptDto";
import getQueryParamsFromMap from "utils/getQueryParamsFromMap";

interface QueryParams {
  includeQuestions?: boolean;
}

interface Params {
  scriptId?: string;
  queryParams?: QueryParams;
}

const defaultQueryParams = {
  sort: "createdOn",
  includeQuestions: true,
};

export default function useGetScriptById({ scriptId, queryParams }: Params) {
  const { projectId } = useProject();
  const { result, ...rest } = useApiGet<IndividualItemResponse<ScriptDto>>(
    scriptId
      ? endpoints.getScriptById(
          projectId,
          scriptId,
          getQueryParamsFromMap({ ...defaultQueryParams, ...queryParams }),
        )
      : "",
  );

  return { script: result?.data, ...rest };
}
